import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { getSeasonStartDate } from '../config/seasonDates';

dayjs.extend(utc);

export const getGlobalStartDate = (season, year) => {
  const { month, day } = getSeasonStartDate(season, year);
  return dayjs.utc(`${year}-${month + 1}-${day}`, 'YYYY-M-D');
};

export const getDayIndex = (date, globalStartDate) => {
  const dateUTC = dayjs.utc(date).startOf('day');
  const startUTC = dayjs.utc(globalStartDate).startOf('day');
  const daysDiff = dateUTC.diff(startUTC, 'day');
  return ((daysDiff % 28) + 28) % 28;
};

export const getCurrentSeason = () => {
  const now = dayjs();
  const month = now.month();
  return month >= 3 && month <= 8 ? 'spring-summer' : 'fall-winter';
};

export const getMealsForDay = async (facilityId, date) => {
  try {
    const dateStr = dayjs.utc(date).format('YYYY-MM-DD');
    const docRef = doc(
      db,
      `facilityCorporateMeals/${facilityId}/days/${dateStr}`,
    );
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();

      const processMeal = (meal) => {
        const visibleCorporate = meal.corporateItems.filter(
          (item) => !meal.hiddenItems.includes(item),
        );
        return [...visibleCorporate, ...meal.localItems];
      };

      return {
        breakfast: {
          items: processMeal(data.breakfast),
          source: 'mixed',
        },
        lunch: {
          items: processMeal(data.lunch),
          source: 'mixed',
        },
        dinner: {
          items: processMeal(data.dinner),
          source: 'mixed',
        },
      };
    }

    return null;
  } catch (error) {
    console.error('Error getting meals for day:', error);
    return null;
  }
};

export const formatSeason = (season) => {
  return season === 'spring-summer' ? 'Spring & Summer' : 'Fall & Winter';
};

export const getSeasonColor = (season) => {
  return season === 'spring-summer' ? '#4caf50' : '#ff9800';
};

export const validateStartDate = (startDate, season) => {
  const startUTC = dayjs.utc(startDate).startOf('day');
  const year = startUTC.year();
  const month = startUTC.month();
  const day = startUTC.date();

  const { month: startMonth, day: startDay } = getSeasonStartDate(season, year);

  const configuredStartDate = dayjs.utc(
    `${year}-${startMonth + 1}-${startDay}`,
    'YYYY-M-D',
  );
  const endDate = configuredStartDate.add(27, 'day');

  const endMonth = endDate.month();
  const endDay = endDate.date();

  const inputDate = dayjs.utc(startDate).startOf('day');
  const isWithinWindow =
    (inputDate.isSame(configuredStartDate, 'day') ||
      inputDate.isAfter(configuredStartDate, 'day')) &&
    (inputDate.isSame(endDate, 'day') || inputDate.isBefore(endDate, 'day'));

  if (!isWithinWindow) {
    const startFormatted = configuredStartDate.format('MMMM D');
    const endFormatted = endDate.format('MMMM D');
    return {
      valid: false,
      message: `Start date must be between ${startFormatted} and ${endFormatted} (any year)`,
    };
  }

  return { valid: true };
};
